import { DESTINATIONS } from "../data/site";

export default function Marquee() {
  const list = [...DESTINATIONS, ...DESTINATIONS];
  return (
    <section
      data-testid="marquee-section"
      className="py-24 md:py-32 border-y border-black/10 overflow-hidden bg-[color:var(--bs-bg)]"
    >
      <div className="overline text-center mb-10 text-[color:var(--bs-muted)]">
        Destinations · Belgique
      </div>
      <div className="relative flex w-max bs-marquee-track">
        {list.map((d, i) => (
          <span
            key={i}
            className="font-display text-[9vw] md:text-[7vw] font-light tracking-tight text-[color:var(--bs-ink)] whitespace-nowrap px-16 md:px-24"
          >
            {d}
            <span className="text-[color:var(--bs-gold)] mx-8 md:mx-12">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
